import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DeliveryKeys } from 'swag-client-common/constants/delivery';
import { editFieldAction, editCountryAction, editShippingStateAction, shippingNameEditAction, updateShippingNameAction, validateShippingField } from '../../../redux/giveaway-landing/giveaway-landing.actions';
import { giveawayErrorSelector, giveawayLinkFormWithEmailSelector, hasGiveawayErrorSelector, isGoodieGiveawayLanding, shippingAddressValuesSelector, giveawayDeliveryInternationalErrorSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { getAddressByPlaceAction, getAddressesAction, getPlaceByIdAction, setManualAddressEnterAction } from '../../../redux/giveaway-landing/reducers/autocomplete/autocomplete.actions';
import { autocompleteListSelector, isAddressLoadingSelector, isAddressEnteredManuallySelector } from '../../../redux/giveaway-landing/reducers/autocomplete/autocomplete.selectors';
import GiveawayShippingFormComponent from './giveaway-shipping-form';
const mapStateToProps = createStructuredSelector({
  values: shippingAddressValuesSelector,
  hasError: hasGiveawayErrorSelector,
  error: giveawayErrorSelector,
  withEmail: giveawayLinkFormWithEmailSelector,
  autocompleteList: autocompleteListSelector,
  isAddressLoading: isAddressLoadingSelector,
  isAddressEnteredManually: isAddressEnteredManuallySelector,
  isGoodieGiveaway: isGoodieGiveawayLanding,
  deliveryInternationalError: giveawayDeliveryInternationalErrorSelector
});
const mapDispatchToProps = dispatch => ({
  onEdit: (field, value) => dispatch(editFieldAction(field, value)),
  onShippingFormFocus: () => {
    dispatch(updateShippingNameAction());
  },
  onShippingStateEdit: value => {
    dispatch(editShippingStateAction(value));
  },
  onShippingCountryEdit: value => {
    dispatch(editCountryAction(value));
  },
  onShippingNameEdit: (field, value) => {
    if (field === DeliveryKeys.Zip) {
      dispatch(validateShippingField(field, value));
    }
    dispatch(editFieldAction(field, value));
    dispatch(shippingNameEditAction());
  },
  onAddressFetch: () => {
    dispatch(getAddressesAction());
  },
  onManualEnterClick: () => {
    dispatch(setManualAddressEnterAction());
  },
  onAddressClick: params => {
    dispatch(getAddressByPlaceAction(params));
  },
  onAddressSelect: params => {
    dispatch(getPlaceByIdAction(params));
  }
});
export const GiveawayShippingForm = connect(mapStateToProps, mapDispatchToProps)(GiveawayShippingFormComponent);